export default __webpack_public_path__ + "assets/images/provably-fair-8095b304a070a2c3144be0a6367bb4b4.svg";